export default {
 /* -------------------------------------------------------------------------- */
 /*                             labour Price List State                            */
 /* -------------------------------------------------------------------------- */
 loading: false,
 listLoading: false,
 LabourPriceRecords: [],
 total: 0,
 FilteredCount: 0,
 /* -------------------------------------------------------------------------- */
 /*                            Create labour Price State                           */
 /* -------------------------------------------------------------------------- */
 createLoading: false,
 /* -------------------------------------------------------------------------- */
 /*                             Edit labour Price State                            */
 /* -------------------------------------------------------------------------- */
 editLoading: false
}
